import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { mapGetters } from 'vuex';
import Phone from './Phone.vue';
var Delivery = function Delivery() {
  return import('./Delivery.vue');
};
var Faq = function Faq() {
  return import('./Faq.vue');
};
var Payment = function Payment() {
  return import('./Payment.vue');
};
var Return = function Return() {
  return import('./Return.vue');
};
var TrustPilot = function TrustPilot() {
  return import('./TrustPilot.vue');
};
export default {
  name: 'Reinsurance',
  components: {
    Delivery: Delivery,
    Faq: Faq,
    Payment: Payment,
    Phone: Phone,
    Return: Return,
    TrustPilot: TrustPilot
  },
  props: {
    isScrambleLink: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  })), {}, {
    defaultShowcase: function defaultShowcase() {
      return this.locale.iso === 'fr-FR' || this.locale.iso === 'it-IT';
    }
  })
};